export const LOGO =
  "https://customer-assets-0z36b82j.emergentagent.net/job_forge-addon-launch/artifacts/uw1th6v7_WhatsApp%20Image%202026-02-25%20at%2021.58.55.jpeg";

const SHOT = "https://customer-assets-v7afamib.emergentagent.net/job_17e3b6f3-8355-4897-be18-414f29f4be9b/artifacts";

export const SCREENSHOTS = [
  { src: `${SHOT}/ps3cv765_android_1_1.jpg`, label: "Roll" },
  { src: `${SHOT}/mla1okth_android_1_2.jpg`, label: "Build your dice" },
  { src: `${SHOT}/p00ndgvw_android_1_3.jpg`, label: "Forge a pouch" },
  { src: `${SHOT}/vl7c3ntk_android_1_4.jpg`, label: "Level up" },
  { src: `${SHOT}/plxud2uj_android_1_5.jpg`, label: "Plan and track" },
];

export const HERO_SHOT = `${SHOT}/ps3cv765_android_1_1.jpg`;

export const CHAPTERS = [
  { n: "01", title: "Roll", copy: "Let the dice create the next challenge." },
  { n: "02", title: "Build", copy: "Create your own dice, face by face." },
  { n: "03", title: "Forge", copy: "Combine dice into reusable Pouches." },
  { n: "04", title: "Plan", copy: "Schedule sessions and track the streak." },
  { n: "05", title: "Share", copy: "Post it, challenge the community back." },
];

export const PATH_STEPS = [
  { n: "1", title: "Create", sub: "Your Pouches" },
  { n: "2", title: "Combine", sub: "Your Dice" },
  { n: "3", title: "Schedule", sub: "Your challenge" },
  { n: "4", title: "Execute", sub: "Your Forge" },
  { n: "5", title: "Share", sub: "Your ideas" },
];

export const AMSER = [
  {
    key: "A",
    name: "Action",
    color: "#ff3434",
    definition: "The movement itself. What your body is about to do.",
    faces: ["Pull-Ups", "Dips", "Chin-Ups", "Pike Push-Ups", "Inverted Rows", "Broad Jumps"],
  },
  {
    key: "M",
    name: "Measure",
    color: "#3f82ff",
    definition: "How much of it. Reps, seconds, distance — the size of the set.",
    faces: ["6 Reps", "8 Reps", "12 Reps", "20 Sec", "40 Sec", "1 Min"],
  },
  {
    key: "S",
    name: "Structure",
    color: "#35c978",
    definition: "The shape of each rep. How the movement is performed.",
    faces: [
      "Pause Each Time",
      "Continuous Motion",
      "Fast Going Up",
      "Slow Going Down",
      "Pause at the Bottom",
      "Squeeze at the Top",
    ],
  },
  {
    key: "E",
    name: "Effort",
    color: "#e0b53a",
    definition: "How hard you push. The intensity of the set.",
    faces: ["Easy", "Steady", "Working", "Hard", "Very Hard", "Near Max"],
  },
  {
    key: "R",
    name: "Recovery",
    color: "#9b6bff",
    definition: "The rest between. Short rest bites, long rest builds.",
    faces: ["15 Sec Rest", "30 Sec Rest", "45 Sec Rest", "1 Min Rest", "90 Sec Rest", "Walk It Off"],
  },
];

export const MARQUEE_WORDS = [
  "PULL-UPS",
  "8 REPS",
  "30 SEC",
  "WORKING",
  "RECOVERY",
  "DIPS",
  "NEAR MAX",
  "SLOW GOING DOWN",
  "CHIN-UPS",
  "CONTINUOUS MOTION",
  "45 SEC",
  "SQUEEZE AT THE TOP",
  "PIKE PUSH-UPS",
  "PAUSE EACH TIME",
  "WALK IT OFF",
  "VERY HARD",
];

export const REFORGE_FLOW = ["Discover", "Load", "Reforge", "Share", "Challenge"];

export const CHALLENGES = [
  { days: "7", title: "Test", copy: "One week. Find out what a Pouch feels like when you run it back to back." },
  { days: "14", title: "Rhythm", copy: "Two weeks. Lock in the days, the time of day and the rolls that suit you." },
  { days: "30", title: "Start", copy: "Build the habit. Explore your Pouches. Find what works for you." },
  { days: "60", title: "Build", copy: "Increase the challenge. Refine your Pouches. Keep forging your path." },
  { days: "90", title: "Forge", copy: "Commit to the journey. Follow your plan. See what you can build in 90 days." },
];

export const CONSTRAINTS = [
  { icon: "clock", label: "20 Minutes" },
  { icon: "home", label: "At Home" },
  { icon: "body", label: "Full Body" },
  { icon: "target", label: "Intermediate" },
  { icon: "dice", label: "4 Dice" },
];

export const TAG_OPTIONS = [
  "bodyweight",
  "strength",
  "conditioning",
  "mobility",
  "recovery",
  "beginner",
  "advanced",
  "short",
  "at-home",
  "gym",
];

export const FEEDBACK_STATUSES = ["open", "planned", "in progress", "done", "won't do"];
